import { ICrossTherapyArticleLine } from '@alberta/konexi-shared';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

export function getCrossTherapyArticleForm(
  articleLine: ICrossTherapyArticleLine,
  formBuilder: FormBuilder,
  requiresSerialnumber: boolean,
  requiresBatchnumber: boolean,
  showIdentificationNumbers: boolean
) {
  return formBuilder.group({
    _id: [articleLine._id],
    quantity: [articleLine.quantity, quantityValidator],
    serialNumber: [
      articleLine.serialNumber,
      requiresSerialnumber && showIdentificationNumbers ? Validators.required : null,
    ],
    operatingHours: [
      articleLine.operatingHours,
      requiresSerialnumber && showIdentificationNumbers ? Validators.required : null,
    ],
    batchNumber: [
      articleLine.batchNumber,
      requiresBatchnumber && showIdentificationNumbers ? Validators.required : null,
    ],
    storageLocation: [articleLine.storageLocation],
  });
}

function quantityValidator(control: FormControl) {
  if (control.value <= 0) {
    return { quantity: true };
  }
  return null;
}
